const ERROR_MESSAGE_TRANSLATIONS = Object.freeze({
  "File validation failed.": "La validación del fichero ha fallado.",
  "File path does not exist.":
    "La ruta o el fichero especificado no existe.",
  "File name length is too long.":
    "El nombre del fichero excede la longitud máxima permitida.",
  "File size is too large.":
    "El tamaño del fichero supera el límite máximo permitido.",
  "File extension does not match with the resource type.":
    "La extensión del fichero no coincide con el tipo de recurso seleccionado.",
  "File content is not valid or empty.":
    "El contenido del fichero está vacío o su formato es inválido.",
  "There was a problem during the file validation.":
    "Se ha producido un error durante el proceso de validación del fichero.",
  "Invalid Resource Type": "El tipo de recurso indicado no es válido.",
  "SHACL validation failed.": "La validación semántica SHACL ha fallado.",
  "Data graph path does not exist.":
    "No se encuentra el grafo de datos para la validación.",
  "SHACL shapes path does not exist.":
    "No se encuentra el archivo de formas (shapes) SHACL.",
  "Resource already exists.":
    "El recurso que intenta registrar ya existe en el sistema.",
  "DCAT already exists.": "La descripción DCAT ya existe en el catálogo.",
  "However, the resource does not contain the DCAT.":
    "El recurso no contiene la definición DCAT obligatoria.",

  "No metadata found with the provided resource_id":
    "No se han encontrado metadatos asociados al identificador proporcionado.",
  "Metadata update failed: Invalid field(s) provided. Only valid metadata fields can be added or updated.":
    "Actualización fallida: contiene campos no válidos para los metadatos.",
  "The metadata update process failed because Persistor or Opensearch could be down.":
    "Error al actualizar metadatos: el servicio de búsqueda/indexación no está disponible.",
  "No resource found in database with the provided id.":
    "No se ha encontrado ningún recurso en base de datos con ese ID.",
  "More than one resource found in database with the provided id.":
    "Conflicto de integridad: existe más de un recurso con el mismo ID.",
  "RML conversion failed.": "La conversión o mapeo RML ha fallado.",
  "RML conversion failed because the mapper process exceeded the timeout.":
    "La conversión RML ha superado el tiempo máximo de espera (timeout).",
  "RML mapper file and/or source file do not exist.":
    "No se encuentra el archivo de mapeo RML o el archivo origen.",
  "Quality report generation failed because there was an exception during the process.":
    "Error al generar el informe de calidad de los metadatos.",
  "The Unstructured integration process is not yet implemented.":
    "La integración de datos no estructurados aún no está disponible.",

  "File uploading failed.": "Error al subir el archivo al almacenamiento.",
  "File download failed.": "Error al descargar el archivo solicitado.",
  "File does not exist.": "El fichero solicitado no existe en el sistema.",
  "Directory path does not exist.": "El directorio de destino no existe.",

  Unauthorized: "Sesión no autorizada o credenciales no válidas.",
  UNAUTHORIZED: "Sesión no autorizada o credenciales no válidas.",
  "Unauthorized action":
    "No tiene permisos suficientes para ejecutar esta acción.",
  "Invalid token": "El token de autenticación ha caducado o no es válido.",
  "Invalid dsb participant id":
    "El identificador de participante DSB no es válido.",
  "Participant id in payload does not match path participant id":
    "El ID de participante del cuerpo no coincide con el de la URL.",
  "Request body is required":
    "El cuerpo de la petición (JSON) es obligatorio.",
  "body is required": "El cuerpo de la petición (JSON) es obligatorio.",
  "username is required": "El nombre de usuario es un campo obligatorio.",
  "email is required":
    "El formato del correo electrónico no es válido o está vacío.",
  "organization is required":
    "Debe especificar la organización del participante.",
  "At least one client role is required":
    "Debe asignar al menos un rol al usuario.",
  "resourceId is required to delete the resource":
    "Se requiere el ID del recurso para poder eliminarlo.",
  "vocabName is required to retrieve the vocabulary":
    "Debe especificar el nombre del vocabulario.",
  "Data conflict":
    "Conflicto de datos: el registro ya existe o está en uso por otro elemento.",

  "Contract negotiation failed":
    "La negociación del contrato con el conector de destino ha fallado.",
  "Contract offer not found":
    "La oferta de contrato seleccionada ya no está disponible o ha expirado.",
  "Contract definition not found":
    "No se encuentra la definición del contrato asociada al dataset.",
  "Policy evaluation failed: constraint not satisfied":
    "Acceso denegado: no se cumplen las condiciones/políticas de uso del dato.",
  "Transfer process failed":
    "Ha fallado el proceso de transferencia de datos entre conectores.",
  "Catalog request timed out":
    "Tiempo de espera agotado al consultar el catálogo del participante remoto.",
  "Counter party connector unreachable":
    "No se puede establecer comunicación con el conector remoto (DSP).",

  "Bad Request":
    "Petición incorrecta: verifique los datos introducidos en el formulario.",
  "Not Found": "El recurso solicitado no se encuentra disponible.",
  "Conflict":
    "El elemento no se puede procesar o eliminar porque está vinculado a otros datos.",
  "Internal Server Error":
    "Se ha producido un error interno en el servidor. Inténtelo más tarde.",
  "Bad Gateway":
    "El servicio o conector remoto no está respondiendo en este momento.",
  "Service Unavailable":
    "El servicio o conector remoto no está respondiendo en este momento.",
});

const STATUS_TRANSLATIONS = Object.freeze({
  400: "Petición incorrecta: verifique los datos introducidos en el formulario.",
  401: "Su sesión ha expirado o no tiene autorización. Inicie sesión de nuevo.",
  403: "No dispone de los permisos necesarios para realizar esta operación.",
  404: "El recurso solicitado no se encuentra disponible.",
  409: "El elemento no se puede procesar o eliminar porque está vinculado a otros datos.",
  500: "Se ha producido un error interno en el servidor. Inténtelo más tarde.",
  502: "El servicio o conector remoto no está respondiendo en este momento.",
  503: "El servicio o conector remoto no está respondiendo en este momento.",
});

const PATTERN_TRANSLATIONS = Object.freeze([
  {
    pattern:
      /^Invalid connector role: ['"].+['"]\. Allowed values are: admin, data_consumer, data_provider\.?$/i,
    translation:
      "Rol de conector inválido. Valores permitidos: admin, data_consumer, data_provider.",
  },
  {
    pattern: /^Invalid email address: .+$/i,
    translation:
      "El formato del correo electrónico no es válido o está vacío.",
  },
  {
    pattern: /^Role not found: .+$/i,
    translation: "El rol especificado no existe en el sistema de identidades.",
  },
]);

const NORMALIZED_TRANSLATIONS = Object.freeze(
  Object.entries(ERROR_MESSAGE_TRANSLATIONS).reduce((acc, [key, value]) => {
    acc[normalizeErrorMessage(key)] = value;
    return acc;
  }, {}),
);

function normalizeErrorMessage(message) {
  return String(message || "")
    .trim()
    .replace(/^`+|`+$/g, "")
    .replace(/\s+/g, " ")
    .toLowerCase();
}

export function translateErrorMessage(message, status) {
  if (typeof message !== "string" || !message.trim()) {
    return STATUS_TRANSLATIONS[Number(status)] || message;
  }

  return (
    translateKnownErrorMessage(message) ||
    STATUS_TRANSLATIONS[Number(status)] ||
    message.trim()
  );
}

function translateKnownErrorMessage(message) {
  const trimmedMessage = message.trim();
  const normalizedMessage = normalizeErrorMessage(trimmedMessage);
  const exactTranslation = NORMALIZED_TRANSLATIONS[normalizedMessage];

  if (exactTranslation) {
    return exactTranslation;
  }

  const patternTranslation = PATTERN_TRANSLATIONS.find(({ pattern }) =>
    pattern.test(trimmedMessage),
  );

  if (patternTranslation) {
    return patternTranslation.translation;
  }

  return null;
}

export function translateErrorText(text, status) {
  if (typeof text !== "string") {
    return translateErrorMessage(text, status);
  }

  if (!text.includes("\n")) {
    return translateErrorMessage(text, status);
  }

  let didTranslate = false;
  const translatedText = text
    .split("\n")
    .map((line) => {
      const translatedLine = translateKnownErrorMessage(line);
      if (translatedLine) {
        didTranslate = true;
        return translatedLine;
      }
      return line;
    })
    .join("\n");

  return didTranslate
    ? translatedText
    : STATUS_TRANSLATIONS[Number(status)] || text;
}
